import React from 'react';
import { StyledCard } from './index.styles.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Card = React.forwardRef(({ hasPadding = true, className, children, margin, ...rest }, ref) => (React.createElement(StyledCard, { ref: ref, className: className, hasPadding: hasPadding, margin: margin, ...pickA11yProps(rest), ...pickDataProps(rest) }, children)));
Card.displayName = 'Card';
//# sourceMappingURL=index.js.map